import {ChartPDFPlaceholderConstructors, ChartPDFTemplateConstructors} from './ChartPDFDefinitionPartsConstructors'

export default class TableDefinitionBuilder {
    constructor(chartType, valueFormatter, categoryFormatter, grandTotalValue) {

        this.categoryFormatter = categoryFormatter
        this.valueFormatter = valueFormatter
        this.chartType = chartType
        this.templateCtrs = ChartPDFTemplateConstructors
        this.placeholderCtrs = ChartPDFPlaceholderConstructors
        this.grandTotalValue = grandTotalValue
    }

    getTable(dataRows, margins, tableStyle) {
        // abstact
    }

    getDataRows(pageDataList, showDataList, showPercentsList, tableValueStyles, rowDataMaxLens) {
        // abstract
    }

    /**
     * Method returns percent of grand total value
     * @param value - current value
     * @return string with percents
     * @private
     */
    _getPercentValue = function(value) {
        let percents = this.grandTotalValue === 0 ? 0 : (100 * value / this.grandTotalValue)
        percents = percents.toFixed(2)
        percents = percents.replace('.', window.SystemSettings.decimalSeparator)
        return percents + " %"
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/charts/pdfgenerator/TableDefinitionBuilder.js